/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
    Typography,
    TextField,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    Box,
    IconButton,
    TablePagination,
    Chip,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Collapse,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    Alert,
    Divider,
    Tooltip,
    ToggleButton,
    ToggleButtonGroup,
    Card,
    CardContent,
    CardActions,
    useMediaQuery,
    useTheme,
    Checkbox,
    ClickAwayListener,
    Menu,
    Select,
    MenuItem,
    ListItemIcon,
    ListItemText,
    InputLabel,
    Tabs,
    Tab
} from '@mui/material';
import { useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AdminNav from '../AdminNav/AdminNav';
import NotificationPreferencesEditor from './NotificationPreferencesEditor';
import api from '../../utils/axiosConfig';
import { toast } from 'react-toastify';
import { DndContext, closestCenter, PointerSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { restrictToVerticalAxis, restrictToFirstScrollableAncestor } from '@dnd-kit/modifiers';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIconOutlined from '@mui/icons-material/CancelOutlined';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import MoreVertIcon from '@mui/icons-material/MoreVert';


const CaregiverManagement = () => {
    const isValidEmailFormat = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
    const { customerKey } = useParams();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [caregivers, setCaregivers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [selectedCaregiver, setSelectedCaregiver] = useState(null);
    const [editingCaregiverId, setEditingCaregiverId] = useState(null);
    const [editFormData, setEditFormData] = useState({ userType: '', useApp: 1 });
    const [originalFormData, setOriginalFormData] = useState(null);
    const [saveLoading, setSaveLoading] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [phoneUpdateModalOpen, setPhoneUpdateModalOpen] = useState(false);
    const [phoneUpdateStatus, setPhoneUpdateStatus] = useState(''); // 'checking', 'success', 'timeout'
    const [unitStatus, setUnitStatus] = useState(null);
    const [pollCount, setPollCount] = useState(0);
    const [rowsPerPageOptions, setRowsPerPageOptions] = useState([10, 25, 50]);
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const [editedUserKey, setEditedUserKey] = useState(null);
    const [suspendTooltipOpen, setSuspendTooltipOpen] = useState(null); // Track which caregiver's suspend tooltip is open
    const [editTab, setEditTab] = useState(0); // 0 = Basic Info, 1 = Notifications
    const [resendEmailLoading, setResendEmailLoading] = useState(null); // Track which caregiver's email is being resent
    const [resendEmailModalOpen, setResendEmailModalOpen] = useState(false);
    const [resendEmailCaregiver, setResendEmailCaregiver] = useState(null);
    const [phoneNumbersSendLoading, setPhoneNumbersSendLoading] = useState(null);
    const [actionMenuPosition, setActionMenuPosition] = useState(null);
    const [actionMenuCaregiver, setActionMenuCaregiver] = useState(null);
    const token = useSelector((state) => state.auth.token);
    const user = useSelector((state) => state.auth.user);
    const loggedInUserType = useSelector((state) => state.auth.userType?.userType || state.auth.user?.userType || null);
    const UnitSerNum = useSelector((state) => state.auth.activeUnit?.UnitSerNum);
    const customerName = useSelector((state) => state.auth.activeUnit?.FirstName) + ' ' + useSelector((state) => state.auth.activeUnit?.LastName);
    const ActivePhoneNumber = useSelector((state) => state.auth.activeUnit?.ActivePhoneNumber || '');
    
    const smartConnectUnit = useSelector((state) => {
        const mc = state.auth.activeUnit?.MC || "";
        return /smart connect/i.test(mc);
    }); // controls reorder visibility directly
    const isCurrentUserAdmin = loggedInUserType === 'Admin';
    
    const authChecking = useSelector((state) => state.auth.authChecking);
    const [refreshCaregivers, setRefreshCaregivers] = useState(false);
    const [dial911, setDial911] = useState(0);
    // Always-on drag ordering (no explicit mode)
    const [savingOrder, setSavingOrder] = useState(false);
    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
        useSensor(TouchSensor, { activationConstraint: { delay: 250, tolerance: 5 } })
    );


    const saveTimeout = useRef(null);
    const lastPayloadRef = useRef('');
    const timerIntervalRef = useRef(null);
    const pollingTimeoutRef = useRef(null);

    // Create a virtual 911 caregiver for display purposes
    const create911Caregiver = () => ({
        id: '911-virtual',
        FirstName: '911',
        LastName: 'Emergency Services',
        Email: '',
        UserType: 'View',
        CallContact: 1,
        PhoneNumbers: '911',
        UseApp: 0,
        is911Virtual: true, // Flag to identify this as virtual
        ContactOrder: 999999 // High number to place at end
    });

    const fetchCaregivers = useCallback(async () => {
        try {
            setLoading(true);
            const response = await api.get(`/api/caregivers/${customerKey}`);
            let caregiversData = response.data.caregivers || [];
            const customerDial911 = response.data?.dial911 || 0;
            // Update Dial911 state from API response
            setDial911(customerDial911);
            
            // Inject 911 caregiver if smartConnect and Dial911 is enabled
            if (smartConnectUnit && customerDial911 === 1) {
                const callContactCaregivers = caregiversData.filter(c => c.CallContact === 1);
                const nonCallContactCaregivers = caregiversData.filter(c => c.CallContact !== 1);
                const virtual911 = create911Caregiver();
                caregiversData = [...callContactCaregivers, virtual911, ...nonCallContactCaregivers];
            }
            
            setCaregivers(caregiversData);
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch caregivers:', error);
            setLoading(false);
        }
    }, [customerKey, smartConnectUnit]);

    const persistOrder = useCallback((list, draggedCaregiver) => {
        if (saveTimeout.current) clearTimeout(saveTimeout.current);
        // Filter out the virtual 911 caregiver before sending to API
        const realCaregivers = list.filter(c => !c.is911Virtual);
        const payload = JSON.stringify(realCaregivers.map(c => c.id));
        // Avoid resending identical order payload while a save is pending
        if (payload === lastPayloadRef.current && savingOrder) return;
        lastPayloadRef.current = payload;
        
        saveTimeout.current = setTimeout(async () => {
            try {
                setSavingOrder(true);
                await api.post(`/api/caregivers/${customerKey}/reorder`, { order: realCaregivers.map(c => c.id), draggedCaregiver: draggedCaregiver });
                toast.success('Order updated');
            } catch (e) {
                console.error('Failed to save caregiver order', e);
                toast.error('Failed to save order');
                fetchCaregivers();
            } finally {
                setSavingOrder(false);
            }
        }, 400); // debounce 400ms after last drag movement
    }, [customerKey, fetchCaregivers, savingOrder]);

    const handleDragEnd = (event) => {
        if (!smartConnectUnit) return; // safeguard
        const { active, over } = event;
        if (!over || active.id === over.id) return;
        const draggedCaregiver = caregivers.find(c => c.id === event.active.id);
        setCaregivers(prev => {
            // Separate caregivers into categories
            const call = prev.filter(c => c.CallContact && !c.is911Virtual);
            const virtual911 = prev.find(c => c.is911Virtual);
            const nonCall = prev.filter(c => !c.CallContact); // stays at bottom unchanged order
            const oldIndex = call.findIndex(i => i.id === active.id);
            const newIndex = call.findIndex(i => i.id === over.id);
            if (oldIndex === -1 || newIndex === -1) return prev; // ignore drags not in call list
            const newCall = arrayMove(call, oldIndex, newIndex);
            // Reconstruct list: real call caregivers, then 911 (if exists), then non-call
            const combined = virtual911 
                ? [...newCall, virtual911, ...nonCall].map((c, idx) => ({ ...c, ContactOrder: idx + 1 }))
                : [...newCall, ...nonCall].map((c, idx) => ({ ...c, ContactOrder: idx + 1 }));
            persistOrder(combined, draggedCaregiver);
            return combined;
        });
    };

    const handleDragStart = () => {
        if (!smartConnectUnit) return;
        // Close any open edit panel to avoid layout jumps during drag
        if (editingCaregiverId !== null) {
            setEditingCaregiverId(null);
        }
    };

    const SortableRow = ({ caregiver, children }) => {
        const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: caregiver.id });
        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            opacity: isDragging ? 0.6 : 1,
            background: isDragging ? '#f5f5f5' : undefined
        };
        return (
            <TableRow ref={setNodeRef} style={style} hover>
                {children({ attributes, listeners })}
            </TableRow>
        );
    };

    const SortableCard = ({ caregiver, children }) => {
        const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: caregiver.id });
        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            opacity: isDragging ? 0.6 : 1,
        };
        return (
            <Card ref={setNodeRef} style={style} sx={{ mb: 2, position: 'relative' }}>
                {children({ attributes, listeners })}
            </Card>
        );
    };

    const MobileCardView = ({ caregiver, dragHandleProps, is911Virtual }) => {
        const isEditing = editingCaregiverId === caregiver.id;
        const suspendInfo = getSuspendInfo(caregiver);
        
        return (
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, '&:last-child': { pb: 2 } }}>
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="h6" component="div">
                                {caregiver.FirstName} {caregiver.LastName}
                            </Typography>
                            {suspendInfo && (
                                <ClickAwayListener onClickAway={() => isMobile && setSuspendTooltipOpen(null)}>
                                    <Tooltip 
                                        title={suspendInfo.tooltipText} 
                                        arrow
                                        open={isMobile ? suspendTooltipOpen === caregiver.id : undefined}
                                        onClose={isMobile ? () => setSuspendTooltipOpen(null) : undefined}
                                        disableFocusListener={isMobile}
                                        disableHoverListener={isMobile}
                                        disableTouchListener={isMobile}
                                    >
                                        <Box 
                                            sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: isMobile ? 'pointer' : 'default' }}
                                            onClick={isMobile ? () => setSuspendTooltipOpen(suspendTooltipOpen === caregiver.id ? null : caregiver.id) : undefined}
                                        >
                                            {suspendInfo.icons.map((Icon, index) => (
                                                <Icon key={index} sx={{ color: 'warning.main', fontSize: 20 }} />
                                            ))}
                                        </Box>
                                    </Tooltip>
                                </ClickAwayListener>
                            )}
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                            {caregiver.Email}
                        </Typography>
                        <Chip 
                            label={getUserTypeText(caregiver.userType)} 
                            color={getUserTypeColor(caregiver.userType)}
                            size="small" 
                            sx={{ mt: 1 }} 
                        />
                    </Box>
                    
                    {!is911Virtual && (
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Button
                            size="small"
                            startIcon={isEditing ? <KeyboardArrowUpIcon /> : <EditIcon />}
                            onClick={() => handleEditClick(caregiver)}
                        >
                            {isEditing ? 'Close' : 'Edit'}
                        </Button>
                        <Button
                            size="small"
                            color="error"
                            startIcon={<DeleteIcon />}
                            onClick={() => handleDeleteClick(caregiver)}
                            disabled={user && caregiver.id === user.user}
                        >
                            Delete
                        </Button>
                        {hasAdditionalActions(caregiver) && (
                            <Tooltip title="More actions" arrow>
                                <IconButton
                                    size="small"
                                    color="default"
                                    aria-label="more caregiver actions"
                                    onClick={(event) => openActionMenu(event, caregiver)}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>
                    )}
                </Box>
                
                {smartConnectUnit && caregiver.CallContact === 1 && dragHandleProps && !is911Virtual && (
                    <Box 
                        {...dragHandleProps.attributes} 
                        {...dragHandleProps.listeners}
                        data-ptf-ignore="true"
                        sx={{ 
                            cursor: 'grab',
                            touchAction: 'none',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 0.5,
                            p: 1,
                            bgcolor: 'action.hover',
                            borderRadius: 1
                        }}
                    >
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                            {caregivers.findIndex(c => c.id === caregiver.id) + 1}
                        </Typography>
                        <DragIndicatorIcon fontSize="small" />
                    </Box>
                )}
                
                {smartConnectUnit && caregiver.CallContact === 0 && (
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        p: 1 
                    }}>
                        <NotificationsIcon fontSize="small" color="action" />
                        <Typography variant="caption" color="text.secondary">
                            Notify Only
                        </Typography>
                    </Box>
                )}
            </CardContent>
        );
    };

    useEffect(() => {
        if (customerKey) {
            fetchCaregivers();
        }
    }, [customerKey, token, fetchCaregivers]);

    // Cleanup intervals and timeouts on unmount to prevent memory leaks
    useEffect(() => {
        return () => {
            if (timerIntervalRef.current) {
                clearInterval(timerIntervalRef.current);
            }
            if (pollingTimeoutRef.current) {
                clearTimeout(pollingTimeoutRef.current);
            }
        };
    }, []);

    // Handle 15-second timeout for adding phone number to whitelist
    useEffect(() => {
        if (phoneUpdateStatus === 'adding') {
            const timer = setTimeout(() => {
                setPhoneUpdateStatus('added');
            }, 15000);
            return () => clearTimeout(timer);
        }
    }, [phoneUpdateStatus]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleEditClick = (caregiver) => {
        // Convert suspendExpiration from DB UTC format to date-only format for picker
        let pickerSuspendExpiration = '';
        if (caregiver.SuspendExpiration) {
            let dateStr = caregiver.SuspendExpiration;
            // Convert MySQL format to ISO format if needed
            if (dateStr.includes(' ') && !dateStr.includes('T')) {
                dateStr = dateStr.replace(' ', 'T') + 'Z';
            } else if (!dateStr.includes('Z') && dateStr.includes('T')) {
                dateStr = dateStr + 'Z';
            }
            const utcDate = new Date(dateStr);
            const year = utcDate.getFullYear();
            const month = String(utcDate.getMonth() + 1).padStart(2, '0');
            const day = String(utcDate.getDate()).padStart(2, '0');
            // Store the full datetime value but display will show just the date
            pickerSuspendExpiration = `${year}-${month}-${day}T23:59:59`;
        }
        
        const formData = {
            userType: caregiver.userType,
            firstName: caregiver.FirstName,
            lastName: caregiver.LastName,
            email: caregiver.Email,
            useApp: Number(caregiver.UseApp) === 0 ? 0 : 1,
            password: '',
            previousAppUserType: caregiver.userType && caregiver.userType !== 'No Access' ? caregiver.userType : 'View',
            phoneNumbers: caregiver.PhoneNumbers,
            callContact: caregiver.CallContact,
            suspend: caregiver.Suspend || 0,
            suspendExpiration: pickerSuspendExpiration
        };
        
        if (editingCaregiverId === caregiver.id) {
            // Collapse the form if clicking on the same caregiver
            setEditingCaregiverId(null);
            setEditTab(0); // Reset to first tab
            setEditFormData(formData);
            setOriginalFormData(null);
        } else {
            setEditingCaregiverId(caregiver.id);
            setEditTab(0); // Reset to first tab when opening
            setEditFormData(formData);
            // Store original values
            setOriginalFormData(formData);
            // Reset any previous messages
            setSaveError('');
            setSaveSuccess(false);
        }
    };

    const handleCancelEdit = () => {
        setEditingCaregiverId(null);
        setEditFormData({ userType: '', useApp: 1, password: '' });
        setOriginalFormData(null);
        setSaveError('');
        setSaveSuccess(false);
    };

    const applyUseAppToEditData = (currentData, nextUseAppValue) => {
        const normalizedUseApp = Number(nextUseAppValue) === 0 ? 0 : 1;
        const nextData = {
            ...currentData,
            useApp: normalizedUseApp
        };

        if (normalizedUseApp === 0) {
            if (nextData.userType && nextData.userType !== 'No Access') {
                nextData.previousAppUserType = nextData.userType;
            }
            nextData.userType = 'No Access';
            nextData.password = '';
        } else if (!nextData.userType || nextData.userType === 'No Access') {
            nextData.userType = nextData.previousAppUserType || 'View';
        }

        return nextData;
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setEditFormData({
            ...editFormData,
            [name]: value
        });
    };

    const handleUseAppToggle = (_, nextUseAppValue) => {
        if (nextUseAppValue === null) return;
        setEditFormData((prev) => applyUseAppToEditData(prev, nextUseAppValue));
    };

    const handleAddPhoneNumber = () => {
        const updatedPhoneNumbers = [...(editFormData.phoneNumbers || []), ''];
        setEditFormData({
            ...editFormData,
            phoneNumbers: updatedPhoneNumbers
        });
    };

    const handleRemovePhoneNumber = (index) => {
        const updatedPhoneNumbers = editFormData.phoneNumbers.filter((_, i) => i !== index);
        setEditFormData({
            ...editFormData,
            phoneNumbers: updatedPhoneNumbers
        });
    };

    const validatePhoneNumbers = () => {
        if (!editFormData.phoneNumbers || editFormData.phoneNumbers.length === 0) {
            return { isValid: true, errors: [] };
        }

        const errors = [];
        const validPhoneNumbers = [];

        editFormData.phoneNumbers.forEach((phone, index) => {
            if (phone.trim() === '') {
                if (editFormData.phoneNumbers.length === 1) {
                    errors.push(`Phone number cannot be empty`);
                } else {
                    errors.push(`Phone number ${index + 1} cannot be empty`);
                }
                return;
            }

            const digits = phone.replace(/\D/g, '');
            
            if (digits.length !== 10) {
                if (editFormData.phoneNumbers.length === 1) {
                    errors.push(`Phone number must be exactly 10 digits`);
                } else {
                    errors.push(`Phone number ${index + 1} must be exactly 10 digits`);
                }
            } else {
                validPhoneNumbers.push(phone);
            }
        });

        return { 
            isValid: errors.length === 0, 
            errors,
            validPhoneNumbers 
        };
    };

    const handleSaveEdit = async (caregiverId) => {
        setSaveLoading(true);
        setSaveError('');
        setSaveSuccess(false);
        const effectiveUseApp = smartConnectUnit ? (Number(editFormData.useApp) === 0 ? 0 : 1) : 1;
        const originalUseApp = Number((originalFormData && originalFormData.useApp) ?? (caregivers.find(c => c.id === caregiverId)?.UseApp) ?? 1) === 0 ? 0 : 1;
        const isTransitioningToApp = originalUseApp === 0 && effectiveUseApp === 1;
        const effectiveUserType = effectiveUseApp === 0
            ? 'No Access'
            : ((editFormData.userType && editFormData.userType !== 'No Access') ? editFormData.userType : (editFormData.previousAppUserType || 'View'));
        const trimmedEmail = (editFormData.email || '').trim();
        const trimmedPassword = (editFormData.password || '').trim();

        if (effectiveUseApp === 1 && !trimmedEmail) {
            setSaveError('Email is required when Connect App 365 Access is set to Yes.');
            setSaveLoading(false);
            return;
        }
        if (effectiveUseApp === 1 && !isValidEmailFormat(trimmedEmail)) {
            setSaveError('Please enter a valid email format.');
            setSaveLoading(false);
            return;
        }
        if (isTransitioningToApp && !trimmedPassword) {
            setSaveError('Password is required when switching Connect App 365 Access to Yes.');
            setSaveLoading(false);
            return;
        }

        // Validate suspension expiration if suspending
        if (editFormData.suspend > 0 && !editFormData.suspendExpiration) {
            // make a toast for the error
            toast.error('Please set a suspension expiration date.');
            setSaveError('Please set a suspension expiration date.');
            setSaveLoading(false);
            return;
        }

        // Validate phone numbers if CallContact caregiver
        const currentCaregiver = caregivers.find(c => c.id === caregiverId);
        if (Number(editFormData.callContact) === 1) {
            const validation = validatePhoneNumbers();
            if (!validation.isValid) {
                setSaveError(`Please fix the following issues:\n${validation.errors.join('\n')}`);
                setSaveLoading(false);
                return;
            }
        }

        try {
            const originalPhoneNumbers = currentCaregiver?.PhoneNumbers.map(phone => {
                // Remove all non-digits from the phone number
                const digits = phone.replace(/\D/g, '');
                // Format as 1XXXXXXXXXX (add leading 1 if not present and has 10 digits)
                return digits.length === 10 ? `1${digits}` : digits;
            }).join(',') || '';
            const formattedEditPhoneNumbers = editFormData.phoneNumbers?.map(phone => {
                const digits = phone.replace(/\D/g, '');
                return digits.length === 10 ? `1${digits}` : digits;
            });
            
            const url = `/api/caregivers/${customerKey}/${caregiverId}`;
            
            // Prepare data to send - set suspendExpiration to null if suspend is 0
            const dataToSend = {
                ...editFormData,
                useApp: effectiveUseApp,
                userType: effectiveUserType,
                email: effectiveUseApp === 1 ? trimmedEmail : null,
                password: isTransitioningToApp ? trimmedPassword : null,
                smartConnectUnit: smartConnectUnit ? 1 : 0,
                ActivePhoneNumber: ActivePhoneNumber || null,
                suspendExpiration: editFormData.suspend === 0 ? null : editFormData.suspendExpiration,
                originalPhoneNumbers,
                UnitSerNum: UnitSerNum,
                phoneNumbers: editFormData.phoneNumbers?.map(phone => {
                    // Remove all non-digits from the phone number
                    const digits = phone.replace(/\D/g, '');
                    // Format as 1XXXXXXXXXX (add leading 1 if not present and has 10 digits)
                    return digits.length === 10 ? `1${digits}` : digits;
                }).join(',') || '',
                // Include original values for comparison/audit purposes
                originalValues: originalFormData
            };
            
            const response = await api.put(url, dataToSend);

            // Update the caregiver in the local state
            if (caregivers) {
                setCaregivers(caregivers.map(c =>
                    c.id === caregiverId
                        ? { ...c, userType: effectiveUserType, UseApp: effectiveUseApp, Email: effectiveUseApp === 1 ? trimmedEmail : '' }
                        : c
                ));
            }

            setSaveSuccess(true);
            setEditingCaregiverId(null);
            fetchCaregivers();
            let toastMessage = `${editFormData.firstName} ${editFormData.lastName} updated successfully!`;
            toast.success(toastMessage);
            setEditFormData({
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                userType: '',
                useApp: 1,
                phoneNumbers: [],
                callContact: 0
            });
            setOriginalFormData(null);

            // Check if phone numbers were updated
            if (response.data?.phoneNumbersUpdated === true && response.data?.unitStatus) {
                setUnitStatus(response.data.unitStatus);
                setEditedUserKey(caregiverId); // Store the edited user's ID
                setPhoneUpdateModalOpen(true);
                setPhoneUpdateStatus('adding'); // Start adding process
                setPollCount(0);
            }

        } catch (error) {
            console.error('Failed to update caregiver:', error);
            if (error.response?.data?.message) {
                setSaveError(error.response.data.message);
            } else {
                setSaveError('An error occurred while updating permissions. Please try again.');
            }
        } finally {
            setSaveLoading(false);
        }
    };

    const handlePhoneUpdateModalClose = () => {
        // Cleanup intervals and timeouts when closing modal
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
        }
        if (pollingTimeoutRef.current) {
            clearTimeout(pollingTimeoutRef.current);
            pollingTimeoutRef.current = null;
        }
        
        // Close the modal immediately, reset state after transition
        setPhoneUpdateModalOpen(false);
    };

    const handlePhoneUpdateModalExited = () => {
        // Reset all state after modal has fully closed
        setPollCount(0);
        setElapsedSeconds(0);
        setUnitStatus(null);
        setEditedUserKey(null);
        setPhoneUpdateStatus('');
    };

    const startWhitelistPolling = async () => {
        // Clear any existing intervals/timeouts first
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
        }
        if (pollingTimeoutRef.current) {
            clearTimeout(pollingTimeoutRef.current);
        }

        setPhoneUpdateStatus('checking');
        setElapsedSeconds(0);
        const maxAttempts = 6; // 6 attempts * 10 seconds = 60 seconds
        
        // Start the real-time counter (updates every second)
        timerIntervalRef.current = setInterval(() => {
            setElapsedSeconds(prev => prev + 1);
        }, 1000);
        
        const checkSync = async (attempt) => {
            if (attempt >= maxAttempts) {
                if (timerIntervalRef.current) {
                    clearInterval(timerIntervalRef.current);
                    timerIntervalRef.current = null;
                }
                setPhoneUpdateStatus('timeout');
                return;
            }

            try {
                const response = await api.get(`/api/unit/${UnitSerNum}/whitelistSyncStatus`, {
                    params: { userKey: editedUserKey }
                });
                
                if (response.data?.synced === true) {
                    if (timerIntervalRef.current) {
                        clearInterval(timerIntervalRef.current);
                        timerIntervalRef.current = null;
                    }
                    setPhoneUpdateStatus('success');
                    return;
                }
                
                // Continue polling
                setPollCount(attempt + 1);
                pollingTimeoutRef.current = setTimeout(() => checkSync(attempt + 1), 10000); // Check again in 10 seconds
            } catch (error) {
                console.error('Error checking whitelist sync status:', error);
                // Continue polling even on error
                setPollCount(attempt + 1);
                pollingTimeoutRef.current = setTimeout(() => checkSync(attempt + 1), 10000);
            }
        };

        checkSync(0);
    };

    const handleDeleteClick = (caregiver) => {
        setSelectedCaregiver(caregiver);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await api.delete(`/api/caregivers/${customerKey}/${selectedCaregiver.id}?UnitSerNum=${UnitSerNum}&smartConnectUnit=${smartConnectUnit ? 1 : 0}`);

            let toastMessage = `${selectedCaregiver.FirstName} ${selectedCaregiver.LastName} has been successfully removed.`;
            // Remove the deleted caregiver from the list
            setCaregivers(caregivers.filter(c => c.id !== selectedCaregiver.id));
            setDeleteDialogOpen(false);
            setSelectedCaregiver(null);
            toast.success(toastMessage);
        } catch (error) {
            console.error('Failed to delete caregiver:', error);
        }
    };

    const getUserTypeLabel = (userType) => {
        switch (userType) {
            case 'admin':
                return <Chip label="Admin" color="primary" />;
            case 'interactive':
                return <Chip label="Interactive" color="secondary" />;
            case 'view-only':
                return <Chip label="View Only" color="default" />;
            default:
                return <Chip label={userType} color="default" />;
        }
    };

    const getUserTypeText = (userType) => {
        switch (userType) {
            case 'admin':
                return 'Admin';
            case 'interactive':
                return 'Interactive';
            case 'view-only':
                return 'View Only';
            default:
                return userType;
        }
    };

    const getUserTypeColor = (userType) => {
        switch (userType) {
            case 'admin':
                return 'primary';
            case 'interactive':
                return 'secondary';
            case 'view-only':
                return 'default';
            default:
                return 'default';
        }
    };

    const getSuspendInfo = (caregiver) => {
        const suspend = caregiver.Suspend || 0;
        const suspendExpiration = caregiver.SuspendExpiration;
        
        if (suspend === 0) {
            return null; // Not suspended
        }

        let tooltipText = '';
        let icons = [];
        
        if (suspend === 1) {
            icons = [PhoneDisabledIcon];
            tooltipText = 'This caregiver will not receive calls';
        } else if (suspend === 2) {
            icons = [NotificationsOffIcon];
            tooltipText = 'This caregiver will not receive notifications';
        } else if (suspend === 3) {
            icons = [PhoneDisabledIcon, NotificationsOffIcon];
            tooltipText = 'This caregiver will not receive calls or notifications';
        }
        
        if (suspendExpiration) {
            const expirationDate = new Date(suspendExpiration);
            const now = new Date();
            
            // Check if suspension has expired
            if (expirationDate <= now) {
                return null; // Suspension expired
            }
            
            const options = { 
                year: 'numeric', 
                month: 'short', 
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit'
            };
            const formattedDate = expirationDate.toLocaleDateString('en-US', options);
            tooltipText += ` until ${formattedDate}`;
        }
        
        return { icons, tooltipText };
    };

    const handleResendEmailClick = (caregiver) => {
        setResendEmailCaregiver(caregiver);
        setResendEmailModalOpen(true);
    };

    const formatPhoneNumbersForDisplay = (phoneNumbers) => {
        if (Array.isArray(phoneNumbers)) {
            return phoneNumbers.filter(Boolean).join(', ');
        }
        return phoneNumbers || '';
    };

    const handleResendEmailConfirm = async () => {
        if (!resendEmailCaregiver) return;
        
        setResendEmailLoading(resendEmailCaregiver.id);
        try {
            const response = await api.post(`/api/caregivers/${customerKey}/${resendEmailCaregiver.id}/resendWelcomeEmail`, {
                UnitSerNum,
                isSmartConnectUnit: smartConnectUnit,
                activePhoneNumber: ActivePhoneNumber || ''
            });
            
            // Check if SMS was sent instead of email
            if (response.data?.type === 'sms') {
                toast.success(`Welcome SMS sent to ${formatPhoneNumbersForDisplay(resendEmailCaregiver.PhoneNumbers)}`);
            } else {
                toast.success(`Welcome email resent to ${resendEmailCaregiver.Email}`);
            }
        } catch (error) {
            console.error('Error resending welcome message:', error);
            toast.error(error.response?.data?.error || 'Failed to resend welcome message');
        } finally {
            setResendEmailLoading(null);
            setResendEmailModalOpen(false);
            setResendEmailCaregiver(null);
        }
    };

    const handleSendPhoneNumbersToRemember = async (caregiver, deliveryMethod) => {
        if (!smartConnectUnit || !caregiver || !deliveryMethod) return;

        const loadingKey = `${caregiver.id}-${deliveryMethod}`;
        const destination = deliveryMethod === 'sms' ? caregiver.PhoneNumbers : caregiver.Email;

        if (!destination) {
            toast.error(`No ${deliveryMethod === 'sms' ? 'phone number' : 'email'} found for this caregiver`);
            return;
        }

        setPhoneNumbersSendLoading(loadingKey);
        try {
            await api.post(`/api/caregivers/${customerKey}/${caregiver.id}/resendWelcomeEmail`, {
                UnitSerNum,
                isSmartConnectUnit: smartConnectUnit,
                activePhoneNumber: ActivePhoneNumber || '',
                messageType: 'phoneNumbersToRemember',
                deliveryMethod
            });

            toast.success(`"Phone Numbers To Remember" sent by ${deliveryMethod === 'sms' ? 'text' : 'email'} to ${destination}`);
        } catch (error) {
            console.error('Error sending Phone Numbers To Remember:', error);
            toast.error(error.response?.data?.error || 'Failed to send Phone Numbers To Remember');
        } finally {
            setPhoneNumbersSendLoading(null);
        }
    };

    const openActionMenu = (event, caregiver) => {
        setActionMenuPosition({
            top: event.clientY,
            left: event.clientX
        });
        setActionMenuCaregiver(caregiver);
    };

    const closeActionMenu = () => {
        setActionMenuPosition(null);
    };

    const handleActionMenuExited = () => {
        setActionMenuCaregiver(null);
    };

    const hasUsablePhoneNumbers = (phoneNumbers) => {
        if (Array.isArray(phoneNumbers)) {
            return phoneNumbers.some((phone) => typeof phone === 'string' && phone.trim().length > 0);
        }
        return typeof phoneNumbers === 'string' ? phoneNumbers.trim().length > 0 : false;
    };

    const hasUsableEmail = (email) => isValidEmailFormat(email);

    const hasAdditionalActions = (caregiver) => {
        const hasResendOption = caregiver?.UseApp === 1
            ? hasUsableEmail(caregiver?.Email)
            : hasUsablePhoneNumbers(caregiver?.PhoneNumbers);
        return hasResendOption || (smartConnectUnit && hasUsablePhoneNumbers(caregiver?.PhoneNumbers)) || (smartConnectUnit && hasUsableEmail(caregiver?.Email));
    };

    // Show loading state while auth is being checked
    if (authChecking) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                <CircularProgress />
                <Typography variant="body1" sx={{ ml: 2 }}>
                    Authenticating...
                </Typography>
            </Box>
        );
    }

    return (
        <div>
            <AdminNav customerKey={customerKey} />

            <Paper sx={{ 
                maxWidth: "800px", 
                margin: "0 auto", 
                p: { xs: 1, sm: 2 }, 
                mt: 2,
                mx: { xs: 1, sm: 'auto' }
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <Typography variant="h5" component="h1" sx={{ flex: 1, minWidth: 0 }}>
                        Caregiver Management
                    </Typography>
                    {isCurrentUserAdmin && customerKey && (
                        <Tooltip title="Add caregiver">
                            <IconButton component={Link} to={`/caregivers/${encodeURIComponent(customerKey)}/add`}
                                aria-label="Add caregiver" color="primary" sx={{ width: 64, height: 64, flexShrink: 0 }}>
                                <AddIcon sx={{ fontSize: 36 }} />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>

                {smartConnectUnit && dial911 === 1 && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                        <Typography variant="body2">
                            This customer has been configured to dial 911 if no caregivers answer during a device activation.
                        </Typography>
                    </Alert>
                )}

                {savingOrder && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                        <CircularProgress size={16} />
                        <Typography variant="caption" color="text.secondary">
                            Saving order...
                        </Typography>
                    </Box>
                )}

                {loading ? (
                    <Box display="flex" justifyContent="center" p={3}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {caregivers.length === 0 ? (
                            <Typography variant="body1">No caregivers found for this customer.</Typography>
                        ) : (
                            <>
                                {isMobile ? (
                                    // Mobile Card View
                                    <>
                                        {smartConnectUnit && (
                                            <Alert severity="info" sx={{ mb: 2 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <DragIndicatorIcon fontSize="small" />
                                                    <Typography variant="body2">
                                                        Touch and hold the drag handle to reorder call list
                                                    </Typography>
                                                </Box>
                                            </Alert>
                                        )}
                                        
                                        <DndContext
                                            sensors={smartConnectUnit ? sensors : undefined}
                                            collisionDetection={closestCenter}
                                            modifiers={smartConnectUnit ? [restrictToVerticalAxis] : undefined}
                                            onDragStart={handleDragStart}
                                            onDragEnd={handleDragEnd}
                                        >
                                            <SortableContext
                                                items={caregivers.filter((c) => c.CallContact && !c.is911Virtual).map((c) => c.id)}
                                                strategy={verticalListSortingStrategy}
                                            >
                                                {caregivers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((caregiver) => (
                                                    <React.Fragment key={caregiver.id}>
                                                        {caregiver.is911Virtual ? (
                                                            <Card sx={{ mb: 2, opacity: 0.6, backgroundColor: 'action.disabledBackground' }}>
                                                                <MobileCardView caregiver={caregiver} is911Virtual={true} />
                                                            </Card>
                                                        ) : smartConnectUnit && caregiver.CallContact === 1 ? (
                                                            <SortableCard caregiver={caregiver}>
                                                                {({ attributes, listeners }) => (
                                                                    <>
                                                                        <MobileCardView
                                                                            caregiver={caregiver}
                                                                            dragHandleProps={{ attributes, listeners }}
                                                                        />
                                                                    </>
                                                                )}
                                                            </SortableCard>
                                                        ) : (
                                                            <Card sx={{ mb: 2 }}>
                                                                <MobileCardView caregiver={caregiver} />
                                                            </Card>
                                                        )}
                                                        
                                                        {!caregiver.is911Virtual && (
                                                        <Collapse in={editingCaregiverId === caregiver.id} timeout="auto" unmountOnExit>
                                                            <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
                                                                <Typography variant="h6" gutterBottom>
                                                                    Edit Caregiver
                                                                </Typography>

                                                                <Tabs value={editTab} onChange={(e, newValue) => setEditTab(newValue)} sx={{ mb: 2 }}>
                                                                    <Tab label="Basic Info" />
                                                                    <Tab label="Notifications" />
                                                                </Tabs>

                                                                {editTab === 0 && (
                                                                    <>
                                                                        {saveError && (
                                                                            <Alert severity="error" sx={{ mb: 2 }}>
                                                                                {saveError}
                                                                            </Alert>
                                                                        )}

                                                                        {saveSuccess && (
                                                                            <Alert severity="success" sx={{ mb: 2 }}>
                                                                                Caregiver updated successfully!
                                                                            </Alert>
                                                                        )}

                                                                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                                                {caregiver.FirstName} {caregiver.LastName} - {caregiver.Email}
                                                                            </Typography>
                                                                            {smartConnectUnit && isCurrentUserAdmin && (
                                                                                <Box sx={{ mt: 1, mb: 1 }}>
                                                                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                                                                        Connect App 365 Access
                                                                                    </Typography>
                                                                                    <ToggleButtonGroup
                                                                                        exclusive
                                                                                        size="medium"
                                                                                        color="primary"
                                                                                        fullWidth
                                                                                        value={Number(editFormData.useApp) === 0 ? 0 : 1}
                                                                                        onChange={handleUseAppToggle}
                                                                                        disabled={loading || saveLoading}
                                                                                    >
                                                                                        <ToggleButton value={1}>Yes</ToggleButton>
                                                                                        <ToggleButton value={0}>No</ToggleButton>
                                                                                    </ToggleButtonGroup>
                                                                                </Box>
                                                                            )}
                                                                            <TextField margin="normal" required fullWidth id="firstName" label="First Name" name="firstName" autoComplete="given-name" value={editFormData.firstName} onChange={handleFormChange} disabled={loading} />
                                                                            <TextField margin="normal" required fullWidth id="lastName" label="Last Name" name="lastName" autoComplete="family-name" value={editFormData.lastName} onChange={handleFormChange} disabled={loading} />
                                                                            {(Number(editFormData.useApp) === 1) && (
                                                                                <TextField margin="normal" required fullWidth id="email" label="Email" name="email" autoComplete="email" value={editFormData.email} onChange={handleFormChange} disabled={loading} />
                                                                            )}
                                                                            {(smartConnectUnit && Number(originalFormData?.useApp ?? caregiver.UseApp) === 0 && Number(editFormData.useApp) === 1) && (
                                                                                <TextField margin="normal" required fullWidth id="password" label="Password" name="password" type="password" autoComplete="new-password" value={editFormData.password || ''} onChange={handleFormChange} disabled={loading} />
                                                                            )}

                                                                            {smartConnectUnit && (
                                                                                <>
                                                                                    <TextField
                                                                                        margin="normal"
                                                                                        fullWidth
                                                                                        disabled={loading}
                                                                                        label="Phone Number"
                                                                                        placeholder="(XXX)XXX-XXXX"
                                                                                        required
                                                                                        value={(() => {
                                                                                            const phone = Array.isArray(editFormData.phoneNumbers) && editFormData.phoneNumbers.length > 0 ? editFormData.phoneNumbers[0] : editFormData.phoneNumbers || "";
                                                                                            const phoneStr = String(phone || "");
                                                                                            const digits = phoneStr.replace(/\D/g, "");
                                                                                            if (digits.length === 0) return "";
                                                                                            if (digits.length <= 3) return `(${digits}`;
                                                                                            if (digits.length <= 6) return `(${digits.slice(0, 3)})${digits.slice(3)}`;
                                                                                            return `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
                                                                                        })()}
                                                                                        onChange={(e) => {
                                                                                            const value = e.target.value;
                                                                                            const digits = value.replace(/\D/g, "");
                                                                                            if (digits.length <= 10) {
                                                                                                setEditFormData({
                                                                                                    ...editFormData,
                                                                                                    phoneNumbers: digits ? [digits] : [],
                                                                                                });
                                                                                            }
                                                                                        }}
                                                                                        helperText="Phone number to be used for calls or notifications."
                                                                                    />
                                                                                    <Box sx={{ display: "flex", flexDirection: "column", mb: 2, gap: 1 }}>
                                                                                        <ToggleButtonGroup
                                                                                            exclusive
                                                                                            size="small"
                                                                                            color="primary"
                                                                                            fullWidth
                                                                                            value={typeof editFormData.callContact === "number" ? editFormData.callContact : 0}
                                                                                            onChange={(_, val) => {
                                                                                                if (val === null) return;
                                                                                                setEditFormData(prev => ({
                                                                                                    ...prev,
                                                                                                    callContact: val,
                                                                                                }));
                                                                                            }}
                                                                                            disabled={loading || saveLoading}
                                                                                        >
                                                                                            <ToggleButton value={1}>Call / Notify</ToggleButton>
                                                                                            <ToggleButton value={0}>Notify Only</ToggleButton>
                                                                                        </ToggleButtonGroup>
                                                                                        <Typography variant="caption" color="text.secondary">
                                                                                            Call / Notify: caregiver is called when the alert button is pressed. Notify Only: caregiver receives notifications but is not called.
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </>
                                                                            )}

                                                                            {smartConnectUnit && (
                                                                                <>
                                                                                    <Divider sx={{ my: 2 }} />

                                                                                    <Box sx={{ mb: 2 }}>
                                                                                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                                                                            Suspension Settings
                                                                                        </Typography>
                                                                                
                                                                                        <FormControl fullWidth margin="normal">
                                                                                            <InputLabel id="suspend-label">Suspension Type</InputLabel>
                                                                                            <Select
                                                                                                labelId="suspend-label"
                                                                                                id="suspend"
                                                                                                value={editFormData.suspend || 0}
                                                                                                label="Suspension Type"
                                                                                                onChange={(e) => setEditFormData({ ...editFormData, suspend: e.target.value })}
                                                                                                disabled={saveLoading}
                                                                                            >
                                                                                                <MenuItem value={0}>Not Suspended</MenuItem>
                                                                                                <MenuItem value={1}>Suspend Calls Only</MenuItem>
                                                                                                <MenuItem value={2}>Suspend Notifications Only</MenuItem>
                                                                                                <MenuItem value={3}>Suspend Calls and Notifications</MenuItem>
                                                                                            </Select>
                                                                                        </FormControl>

                                                                                        {editFormData.suspend > 0 && (
                                                                                            <TextField
                                                                                                margin="normal"
                                                                                                fullWidth
                                                                                                required
                                                                                                id="suspendExpiration"
                                                                                                label="Suspension Expiration"
                                                                                                type="date"
                                                                                                value={editFormData.suspendExpiration ? editFormData.suspendExpiration.split('T')[0] : ''}
                                                                                                onChange={(e) => {
                                                                                                    const dateValue = e.target.value;
                                                                                                    if (dateValue) {
                                                                                                        // Set time to 23:59:59 for the selected date
                                                                                                        setEditFormData({ ...editFormData, suspendExpiration: `${dateValue}T23:59:59` });
                                                                                                    } else {
                                                                                                        setEditFormData({ ...editFormData, suspendExpiration: dateValue });
                                                                                                    }
                                                                                                }}
                                                                                                disabled={saveLoading}
                                                                                                InputLabelProps={{
                                                                                                    shrink: true,
                                                                                                }}
                                                                                                helperText="Select when the suspension should end (expires at 11:59 PM)"
                                                                                            />
                                                                                        )}
                                                                                    </Box>
                                                                                </>
                                                                            )}

                                                                            {(Number(editFormData.useApp) === 1) && (
                                                                                <>
                                                                                    <Divider sx={{ my: 2 }} />

                                                                                    <FormControl component="fieldset" sx={{ mt: 1, mb: 2 }}>
                                                                                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                                                                            Permission Type
                                                                                        </Typography>
                                                                                        {user && caregiver.id === user.user && (
                                                                                            <Alert severity="info" sx={{ mb: 1 }}>
                                                                                                You cannot modify your own permission level.
                                                                                            </Alert>
                                                                                        )}
                                                                                        <RadioGroup name="userType" value={editFormData.userType} onChange={handleFormChange}>
                                                                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                                                                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                                                                                                    <FormControlLabel
                                                                                                        disabled={saveLoading || (user && caregiver.id === user.user)}
                                                                                                        value="View"
                                                                                                        control={<Radio />}
                                                                                                        label={
                                                                                                            <Box>
                                                                                                                <Typography variant="body2">View Only</Typography>
                                                                                                                <Typography variant="caption" color="text.secondary">
                                                                                                                    Can only view status and location
                                                                                                                </Typography>
                                                                                                            </Box>
                                                                                                        }
                                                                                                    />
                                                                                                </Box>

                                                                                                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                                                                                                    <FormControlLabel
                                                                                                        disabled={saveLoading || (user && caregiver.id === user.user)}
                                                                                                        value="Interactive"
                                                                                                        control={<Radio />}
                                                                                                        label={
                                                                                                            <Box>
                                                                                                                <Typography variant="body2">Interactive</Typography>
                                                                                                                <Typography variant="caption" color="text.secondary">
                                                                                                                    Can view and update location, send chime
                                                                                                                </Typography>
                                                                                                            </Box>
                                                                                                        }
                                                                                                    />
                                                                                                </Box>

                                                                                                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                                                                                                    <FormControlLabel
                                                                                                        disabled={saveLoading || (user && caregiver.id === user.user)}
                                                                                                        value="Admin"
                                                                                                        control={<Radio />}
                                                                                                        label={
                                                                                                            <Box>
                                                                                                                <Typography variant="body2">Admin</Typography>
                                                                                                                <Typography variant="caption" color="text.secondary">
                                                                                                                    Full access including caregiver management
                                                                                                                </Typography>
                                                                                                            </Box>
                                                                                                        }
                                                                                                    />
                                                                                                </Box>
                                                                                            </Box>
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                </>
                                                                            )}

                                                                            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    onClick={handleCancelEdit}
                                                                                    disabled={saveLoading}
                                                                                    startIcon={<CancelIcon />}
                                                                                    fullWidth
                                                                                >
                                                                                    Cancel
                                                                                </Button>
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    onClick={() => handleSaveEdit(caregiver.id)}
                                                                                    disabled={saveLoading}
                                                                                    startIcon={saveLoading ? <CircularProgress size={20} /> : <SaveIcon />}
                                                                                    fullWidth
                                                                                >
                                                                                    {saveLoading ? "Saving..." : "Save"}
                                                                                </Button>
                                                                            </Box>
                                                                        </Box>
                                                                    </>
                                                                )}

                                                                {editTab === 1 && (
                                                                    <NotificationPreferencesEditor
                                                                        customerKey={customerKey}
                                                                        caregiverId={caregiver.id}
                                                                        caregiverName={`${caregiver.FirstName} ${caregiver.LastName}`}
                                                                        smartConnectUnit={smartConnectUnit}
                                                                        useApp={Number(editFormData.useApp ?? caregiver.UseApp) === 0 ? 0 : 1}
                                                                    />
                                                                )}
                                                            </Paper>
                                                        </Collapse>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </SortableContext>
                                        </DndContext>

                                        <TablePagination
                                            rowsPerPageOptions={rowsPerPageOptions}
                                            component="div"
                                            count={caregivers.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </>
                                ) : (
                                    // Desktop Table View
                                    <>
                                        <DndContext sensors={smartConnectUnit ? sensors : undefined} collisionDetection={closestCenter} modifiers={smartConnectUnit ? [restrictToVerticalAxis, restrictToFirstScrollableAncestor] : undefined} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                                            <TableContainer>
                                                <Table aria-label="caregivers table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Name</TableCell>
                                                            <TableCell>Email</TableCell>
                                                            <TableCell>Permission Type</TableCell>
                                                            <TableCell>Actions</TableCell>
                                                            {smartConnectUnit && (
                                                                <TableCell width={80} align="center">
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                                                        Order
                                                                        <Tooltip
                                                                            title="Click and drag the selector to re-order the call list. If there is a bell icon, they have been listed as notify only and cannot be reordered."
                                                                            placement="top"
                                                                            arrow
                                                                        >
                                                                            <IconButton size="small">
                                                                                <HelpOutlineIcon fontSize="small" color="action" />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </Box>
                                                                </TableCell>
                                                            )}
                                                        </TableRow>
                                                    </TableHead>
                                                    <SortableContext items={caregivers.filter((c) => c.CallContact && !c.is911Virtual).map((c) => c.id)} strategy={verticalListSortingStrategy}>
                                                        <TableBody>
                                                            {caregivers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((caregiver) => {
                                                                const suspendInfo = getSuspendInfo(caregiver);
                                                                return (
                                                                    <React.Fragment key={caregiver.id}>
                                                                        {caregiver.is911Virtual ? (
                                                                            <TableRow sx={{ opacity: 0.6, backgroundColor: 'action.disabledBackground' }}>
                                                                                <TableCell component="th" scope="row">
                                                                                    {caregiver.FirstName} {caregiver.LastName}
                                                                                </TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell>
                                                                                    <Chip 
                                                                                        label="Emergency" 
                                                                                        color="error"
                                                                                        size="small" 
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell></TableCell>
                                                                                {smartConnectUnit && (
                                                                                    <TableCell align="center">
                                                                                        <Typography variant="caption" color="text.secondary">
                                                                                            N/A
                                                                                        </Typography>
                                                                                    </TableCell>
                                                                                )}
                                                                            </TableRow>
                                                                        ) : smartConnectUnit && caregiver.CallContact ? (
                                                                            <SortableRow caregiver={caregiver}>
                                                                                {({ attributes, listeners }) => (
                                                                                    <>
                                                                                        <TableCell component="th" scope="row">
                                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                                                {caregiver.FirstName} {caregiver.LastName}
                                                                                                {suspendInfo && (
                                                                                                    <ClickAwayListener onClickAway={() => isMobile && setSuspendTooltipOpen(null)}>
                                                                                                        <Tooltip
                                                                                                            title={suspendInfo.tooltipText}
                                                                                                            arrow
                                                                                                            open={isMobile ? suspendTooltipOpen === caregiver.id : undefined}
                                                                                                            onClose={isMobile ? () => setSuspendTooltipOpen(null) : undefined}
                                                                                                            disableFocusListener={isMobile}
                                                                                                            disableHoverListener={isMobile}
                                                                                                            disableTouchListener={isMobile}
                                                                                                        >
                                                                                                            <Box
                                                                                                                sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: isMobile ? 'pointer' : 'default' }}
                                                                                                                onClick={isMobile ? () => setSuspendTooltipOpen(suspendTooltipOpen === caregiver.id ? null : caregiver.id) : undefined}
                                                                                                            >
                                                                                                                {suspendInfo.icons.map((Icon, index) => (
                                                                                                                    <Icon key={index} sx={{ color: 'warning.main', fontSize: 20 }} />
                                                                                                                ))}
                                                                                                            </Box>
                                                                                                        </Tooltip>
                                                                                                    </ClickAwayListener>
                                                                                                )}
                                                                                            </Box>
                                                                                        </TableCell>
                                                                                        <TableCell>{caregiver.Email}</TableCell>
                                                                                        <TableCell>{getUserTypeLabel(caregiver.userType)}</TableCell>
                                                                                        <TableCell>
                                                                                            <IconButton color="primary" aria-label="edit caregiver" onClick={() => handleEditClick(caregiver)}>
                                                                                                {editingCaregiverId === caregiver.id ? <KeyboardArrowUpIcon /> : <EditIcon />}
                                                                                            </IconButton>
                                                                                            <IconButton color="error" aria-label="delete caregiver" disabled={user && caregiver.id === user.user} onClick={() => handleDeleteClick(caregiver)}>
                                                                                                <DeleteIcon />
                                                                                            </IconButton>
                                                                                            {hasAdditionalActions(caregiver) && (
                                                                                                <Tooltip title="More actions" arrow>
                                                                                                    <IconButton
                                                                                                        color="default"
                                                                                                        aria-label="more caregiver actions"
                                                                                                        onClick={(event) => openActionMenu(event, caregiver)}
                                                                                                    >
                                                                                                        <MoreVertIcon />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                            )}
                                                                                        </TableCell>
                                                                                        <TableCell align="center" data-ptf-ignore="true" {...attributes} {...listeners} sx={{ cursor: "grab" }}>
                                                                                            <Box sx={{
                                                                                                display: 'grid',
                                                                                                gridTemplateColumns: 'auto auto',
                                                                                                gap: 0.5,
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center'
                                                                                            }}>
                                                                                                <Typography variant="caption" color="text.secondary">
                                                                                                    {caregivers.findIndex(c => c.id === caregiver.id) + 1}
                                                                                                </Typography>
                                                                                                <DragIndicatorIcon fontSize="small" />
                                                                                            </Box>
                                                                                        </TableCell>
                                                                                    </>
                                                                                )}
                                                                            </SortableRow>
                                                                        ) : (
                                                                            <TableRow>
                                                                                <TableCell component="th" scope="row">
                                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                                        {caregiver.FirstName} {caregiver.LastName}
                                                                                        {suspendInfo && (
                                                                                            <ClickAwayListener onClickAway={() => isMobile && setSuspendTooltipOpen(null)}>
                                                                                                <Tooltip
                                                                                                    title={suspendInfo.tooltipText}
                                                                                                    arrow
                                                                                                    open={isMobile ? suspendTooltipOpen === caregiver.id : undefined}
                                                                                                    onClose={isMobile ? () => setSuspendTooltipOpen(null) : undefined}
                                                                                                    disableFocusListener={isMobile}
                                                                                                    disableHoverListener={isMobile}
                                                                                                    disableTouchListener={isMobile}
                                                                                                >
                                                                                                    <Box
                                                                                                        sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: isMobile ? 'pointer' : 'default' }}
                                                                                                        onClick={isMobile ? () => setSuspendTooltipOpen(suspendTooltipOpen === caregiver.id ? null : caregiver.id) : undefined}
                                                                                                    >
                                                                                                        {suspendInfo.icons.map((Icon, index) => (
                                                                                                            <Icon key={index} sx={{ color: 'warning.main', fontSize: 20 }} />
                                                                                                        ))}
                                                                                                    </Box>
                                                                                                </Tooltip>
                                                                                            </ClickAwayListener>
                                                                                        )}
                                                                                    </Box>
                                                                                </TableCell>
                                                                                <TableCell>{caregiver.Email}</TableCell>
                                                                                <TableCell>{getUserTypeLabel(caregiver.userType)}</TableCell>
                                                                                <TableCell>
                                                                                    <IconButton color="primary" aria-label="edit caregiver" onClick={() => handleEditClick(caregiver)}>
                                                                                        {editingCaregiverId === caregiver.id ? <KeyboardArrowUpIcon /> : <EditIcon />}
                                                                                    </IconButton>
                                                                                    <IconButton color="error" aria-label="delete caregiver" disabled={user && caregiver.id === user.user} onClick={() => handleDeleteClick(caregiver)}>
                                                                                        <DeleteIcon />
                                                                                    </IconButton>
                                                                                    {hasAdditionalActions(caregiver) && (
                                                                                        <Tooltip title="More actions" arrow>
                                                                                            <IconButton
                                                                                                color="default"
                                                                                                aria-label="more caregiver actions"
                                                                                                onClick={(event) => openActionMenu(event, caregiver)}
                                                                                            >
                                                                                                <MoreVertIcon />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </TableCell>
                                                                                {smartConnectUnit && (
                                                                                    <TableCell align="center">
                                                                                        <Box sx={{
                                                                                            display: 'grid',
                                                                                            gridTemplateColumns: '1fr',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            placeItems: 'center'
                                                                                        }}>
                                                                                            <NotificationsIcon fontSize="small" color="action" />
                                                                                        </Box>
                                                                                    </TableCell>
                                                                                )}
                                                                            </TableRow>
                                                                        )}
                                                                        <TableRow>
                                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={smartConnectUnit ? 5 : 4}>
                                                                                <Collapse in={editingCaregiverId === caregiver.id} timeout="auto" unmountOnExit>
                                                                                    <Box sx={{ margin: 2, pb: 2 }}>
                                                                                        <Typography variant="h6" gutterBottom component="div">
                                                                                            Edit
                                                                                        </Typography>

                                                                                        <Tabs value={editTab} onChange={(e, newValue) => setEditTab(newValue)} sx={{ mb: 2 }}>
                                                                                            <Tab label="Basic Info" />
                                                                                            <Tab label="Notifications" />
                                                                                        </Tabs>

                                                                                        {editTab === 0 && (
                                                                                            <>
                                                                                                {saveError && (
                                                                                                    <Alert severity="error" sx={{ mb: 2 }}>
                                                                                                        {saveError}
                                                                                                    </Alert>
                                                                                                )}

                                                                                                {saveSuccess && (
                                                                                                    <Alert severity="success" sx={{ mb: 2 }}>
                                                                                                        Caregiver updated successfully!
                                                                                                    </Alert>
                                                                                                )}

                                                                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                                                                    {smartConnectUnit && isCurrentUserAdmin && (
                                                                                                        <Box sx={{ mt: 1, mb: 1 }}>
                                                                                                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                                                                                                Connect App 365 Access
                                                                                                            </Typography>
                                                                                                            <ToggleButtonGroup
                                                                                                                exclusive
                                                                                                                size="small"
                                                                                                                color="primary"
                                                                                                                value={Number(editFormData.useApp) === 0 ? 0 : 1}
                                                                                                                onChange={handleUseAppToggle}
                                                                                                                disabled={loading || saveLoading}
                                                                                                            >
                                                                                                                <ToggleButton value={1}>Yes</ToggleButton>
                                                                                                                <ToggleButton value={0}>No</ToggleButton>
                                                                                                            </ToggleButtonGroup>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                    <TextField margin="normal" required fullWidth id="firstName" label="First Name" name="firstName" autoComplete="given-name" value={editFormData.firstName} onChange={handleFormChange} disabled={loading} />
                                                                                                    <TextField margin="normal" required fullWidth id="lastName" label="Last Name" name="lastName" autoComplete="family-name" value={editFormData.lastName} onChange={handleFormChange} disabled={loading} />
                                                                                                    {(Number(editFormData.useApp) === 1) && (
                                                                                                        <TextField margin="normal" required fullWidth id="email" label="Email" name="email" autoComplete="email" value={editFormData.email} onChange={handleFormChange} disabled={loading} />
                                                                                                    )}
                                                                                                    {(smartConnectUnit && Number(originalFormData?.useApp ?? caregiver.UseApp) === 0 && Number(editFormData.useApp) === 1) && (
                                                                                                        <TextField margin="normal" required fullWidth id="password-desktop" label="Password" name="password" type="password" autoComplete="new-password" value={editFormData.password || ''} onChange={handleFormChange} disabled={loading} />
                                                                                                    )}

                                                                                                    {smartConnectUnit && (
                                                                                                        <>
                                                                                                            <TextField
                                                                                                                margin="normal"
                                                                                                                fullWidth
                                                                                                                disabled={loading}
                                                                                                                label="Phone Number"
                                                                                                                placeholder="(XXX)XXX-XXXX"
                                                                                                                required
                                                                                                                value={(() => {
                                                                                                                    const phone = Array.isArray(editFormData.phoneNumbers) && editFormData.phoneNumbers.length > 0 ? editFormData.phoneNumbers[0] : editFormData.phoneNumbers || "";

                                                                                                                    // Ensure phone is a string before calling replace
                                                                                                                    const phoneStr = String(phone || "");

                                                                                                                    // Format phone number as (XXX)XXX-XXXX
                                                                                                                    const digits = phoneStr.replace(/\D/g, "");
                                                                                                                    if (digits.length === 0) return "";
                                                                                                                    if (digits.length <= 3) return `(${digits}`;
                                                                                                                    if (digits.length <= 6) return `(${digits.slice(0, 3)})${digits.slice(3)}`;
                                                                                                                    return `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
                                                                                                                })()}
                                                                                                                onChange={(e) => {
                                                                                                                    const value = e.target.value;
                                                                                                                    const digits = value.replace(/\D/g, "");

                                                                                                                    // Limit to 10 digits
                                                                                                                    if (digits.length <= 10) {
                                                                                                                        setEditFormData({
                                                                                                                            ...editFormData,
                                                                                                                            phoneNumbers: digits ? [digits] : [],
                                                                                                                        });
                                                                                                                    }
                                                                                                                }}
                                                                                                                helperText="Phone number to be used for calls or notifications."
                                                                                                            />
                                                                                                            <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1 }}>
                                                                                                                <ToggleButtonGroup
                                                                                                                    exclusive
                                                                                                                    size="small"
                                                                                                                    color="primary"
                                                                                                                    value={typeof editFormData.callContact === "number" ? editFormData.callContact : 0}
                                                                                                                    onChange={(_, val) => {
                                                                                                                        if (val === null) return;
                                                                                                                        setEditFormData(prev => ({
                                                                                                                            ...prev,
                                                                                                                            callContact: val,
                                                                                                                        }));
                                                                                                                    }}
                                                                                                                    disabled={loading || saveLoading}
                                                                                                                >
                                                                                                                    <ToggleButton value={1}>Call / Notify</ToggleButton>
                                                                                                                    <ToggleButton value={0}>Notify Only</ToggleButton>
                                                                                                                </ToggleButtonGroup>
                                                                                                                <Tooltip
                                                                                                                    title="Call / Notify: caregiver is called when the alert button is pressed. Notify Only: caregiver receives notifications but is not called."
                                                                                                                    placement="right"
                                                                                                                    arrow
                                                                                                                >
                                                                                                                    <IconButton size="small">
                                                                                                                        <HelpOutlineIcon fontSize="small" color="action" />
                                                                                                                    </IconButton>
                                                                                                                </Tooltip>
                                                                                                            </Box>
                                                                                                        </>
                                                                                                    )}

                                                                                    

                                                                                                    {(Number(editFormData.useApp) === 1) && (
                                                                                                        <>
                                                                                                            <Divider sx={{ my: 2 }} />

                                                                                                            <FormControl component="fieldset" sx={{ mt: 1, mb: 2 }}>
                                                                                                                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                                                                                                    Permission Type
                                                                                                                </Typography>
                                                                                                                {user && caregiver.id === user.user && (
                                                                                                                    <Alert severity="info" sx={{ mb: 1 }}>
                                                                                                                        You cannot modify your own permission level.
                                                                                                                    </Alert>
                                                                                                                )}
                                                                                                                <RadioGroup name="userType" value={editFormData.userType} onChange={handleFormChange}>
                                                                                                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                                                                                                        <FormControlLabel disabled={saveLoading || (user && caregiver.id === user.user)} value="View" control={<Radio />} label="View Only" />
                                                                                                                        <Tooltip title="Can only view the status and location (if applicable) of the customer." placement="right" arrow>
                                                                                                                            <IconButton size="small">
                                                                                                                                <HelpOutlineIcon fontSize="small" color="action" />
                                                                                                                            </IconButton>
                                                                                                                        </Tooltip>
                                                                                                                    </Box>

                                                                                                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                                                                                                        <FormControlLabel disabled={saveLoading || (user && caregiver.id === user.user)} value="Interactive" control={<Radio />} label="Interactive" />
                                                                                                                        <Tooltip title="Can view customer status and location, plus update location and send chime commands (if applicable)." placement="right" arrow>
                                                                                                                            <IconButton size="small">
                                                                                                                                <HelpOutlineIcon fontSize="small" color="action" />
                                                                                                                            </IconButton>
                                                                                                                        </Tooltip>
                                                                                                                    </Box>

                                                                                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                                                                        <FormControlLabel disabled={saveLoading || (user && caregiver.id === user.user)} value="Admin" control={<Radio />} label="Admin" />
                                                                                                                        <Tooltip title="Full access: Can view status and location, update location, send chime commands, and manage customer's caregivers." placement="right" arrow>
                                                                                                                            <IconButton size="small">
                                                                                                                                <HelpOutlineIcon fontSize="small" color="action" />
                                                                                                                            </IconButton>
                                                                                                                        </Tooltip>
                                                                                                                    </Box>
                                                                                                                </RadioGroup>
                                                                                                            </FormControl>
                                                                                                        </>
                                                                                                    )}
                                                                                                    {smartConnectUnit && (
                                                                                                        <>
                                                                                                            <Divider sx={{ my: 2 }} />

                                                                                                            <Box sx={{ mb: 2 }}>
                                                                                                                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                                                                                                    Suspension Settings
                                                                                                                </Typography>

                                                                                                                <FormControl fullWidth margin="normal">
                                                                                                                    <InputLabel id="suspend-label-desktop">Suspension Type</InputLabel>
                                                                                                                    <Select
                                                                                                                        labelId="suspend-label-desktop"
                                                                                                                        id="suspend-desktop"
                                                                                                                        value={editFormData.suspend || 0}
                                                                                                                        label="Suspension Type"
                                                                                                                        onChange={(e) => setEditFormData({ ...editFormData, suspend: e.target.value })}
                                                                                                                        disabled={saveLoading}
                                                                                                                    >
                                                                                                                        <MenuItem value={0}>Not Suspended</MenuItem>
                                                                                                                        <MenuItem value={1}>Suspend Calls Only</MenuItem>
                                                                                                                        <MenuItem value={2}>Suspend Notifications Only</MenuItem>
                                                                                                                        <MenuItem value={3}>Suspend Calls and Notifications</MenuItem>
                                                                                                                    </Select>
                                                                                                                </FormControl>

                                                                                                                {editFormData.suspend > 0 && (
                                                                                                                    <TextField
                                                                                                                        margin="normal"
                                                                                                                        fullWidth
                                                                                                                        required
                                                                                                                        id="suspendExpiration-desktop"
                                                                                                                        label="Suspension Expiration"
                                                                                                                        type="date"
                                                                                                                        value={editFormData.suspendExpiration ? editFormData.suspendExpiration.split('T')[0] : ''}
                                                                                                                        onChange={(e) => {
                                                                                                                            const dateValue = e.target.value;
                                                                                                                            if (dateValue) {
                                                                                                                                // Set time to 23:59:59 for the selected date
                                                                                                                                setEditFormData({ ...editFormData, suspendExpiration: `${dateValue}T23:59:59` });
                                                                                                                            } else {
                                                                                                                                setEditFormData({ ...editFormData, suspendExpiration: dateValue });
                                                                                                                            }
                                                                                                                        }}
                                                                                                                        disabled={saveLoading}
                                                                                                                        InputLabelProps={{
                                                                                                                            shrink: true,
                                                                                                                        }}
                                                                                                                        helperText="Select when the suspension should end (expires at 11:59 PM)"
                                                                                                                    />
                                                                                                                )}
                                                                                                            </Box>
                                                                                                        </>
                                                                                                    )}

                                                                                                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                                                                                        <Button variant="outlined" onClick={handleCancelEdit} disabled={saveLoading} startIcon={<CancelIcon />} sx={{ mr: 1 }}>
                                                                                                            Cancel
                                                                                                        </Button>
                                                                                                        <Button variant="contained" color="primary" onClick={() => handleSaveEdit(caregiver.id)} disabled={saveLoading} startIcon={saveLoading ? <CircularProgress size={20} /> : <SaveIcon />}>
                                                                                                            {saveLoading ? "Saving..." : "Save"}
                                                                                                        </Button>
                                                                                                    </Box>
                                                                                                </Box>
                                                                                            </>
                                                                                        )}

                                                                                        {editTab === 1 && (
                                                                                            <NotificationPreferencesEditor
                                                                                                customerKey={customerKey}
                                                                                                caregiverId={caregiver.id}
                                                                                                caregiverName={`${caregiver.FirstName} ${caregiver.LastName}`}
                                                                                                smartConnectUnit={smartConnectUnit}
                                                                                                useApp={Number(editFormData.useApp ?? caregiver.UseApp) === 0 ? 0 : 1}
                                                                                            />
                                                                                        )}
                                                                                    </Box>
                                                                                </Collapse>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </TableBody>
                                                    </SortableContext>
                                                </Table>
                                            </TableContainer>
                                        </DndContext>
                                        <TablePagination rowsPerPageOptions={rowsPerPageOptions} component="div" count={caregivers.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}
            </Paper>

            <Menu
                anchorReference="anchorPosition"
                anchorPosition={actionMenuPosition ? { top: actionMenuPosition.top, left: actionMenuPosition.left } : undefined}
                open={Boolean(actionMenuPosition)}
                onClose={closeActionMenu}
                TransitionProps={{ onExited: handleActionMenuExited }}
            >
                <MenuItem
                    onClick={() => {
                        const caregiver = actionMenuCaregiver;
                        closeActionMenu();
                        if (caregiver) handleResendEmailClick(caregiver);
                    }}
                    disabled={
                        resendEmailLoading === actionMenuCaregiver?.id ||
                        (actionMenuCaregiver?.UseApp === 1 ? !hasUsableEmail(actionMenuCaregiver?.Email) : !hasUsablePhoneNumbers(actionMenuCaregiver?.PhoneNumbers))
                    }
                >
                    <ListItemIcon>
                        {resendEmailLoading === actionMenuCaregiver?.id ? (
                            <CircularProgress size={18} />
                        ) : (
                            actionMenuCaregiver?.UseApp === 1 ? <EmailIcon fontSize="small" /> : <SmsIcon fontSize="small" />
                        )}
                    </ListItemIcon>
                    <ListItemText primary={actionMenuCaregiver?.UseApp === 1 ? 'Resend Welcome Email' : 'Resend Welcome SMS'} />
                </MenuItem>

                {smartConnectUnit && hasUsablePhoneNumbers(actionMenuCaregiver?.PhoneNumbers) && (
                    <MenuItem
                        onClick={() => {
                            const caregiver = actionMenuCaregiver;
                            closeActionMenu();
                            if (caregiver) handleSendPhoneNumbersToRemember(caregiver, 'sms');
                        }}
                        disabled={phoneNumbersSendLoading === `${actionMenuCaregiver?.id}-sms`}
                    >
                        <ListItemIcon>
                            {phoneNumbersSendLoading === `${actionMenuCaregiver?.id}-sms` ? <CircularProgress size={18} /> : <SmsIcon fontSize="small" />}
                        </ListItemIcon>
                        <ListItemText primary={isMobile ? 'Resend Phone Numbers (SMS)' : 'Resend Phone Numbers To Remember Via SMS'} />
                    </MenuItem>
                )}

                {smartConnectUnit && hasUsableEmail(actionMenuCaregiver?.Email) && (
                    <MenuItem
                        onClick={() => {
                            const caregiver = actionMenuCaregiver;
                            closeActionMenu();
                            if (caregiver) handleSendPhoneNumbersToRemember(caregiver, 'email');
                        }}
                        disabled={phoneNumbersSendLoading === `${actionMenuCaregiver?.id}-email`}
                    >
                        <ListItemIcon>
                            {phoneNumbersSendLoading === `${actionMenuCaregiver?.id}-email` ? <CircularProgress size={18} /> : <EmailIcon fontSize="small" />}
                        </ListItemIcon>
                        <ListItemText primary={isMobile ? 'Resend Phone Numbers (Email)' : 'Resend Phone Numbers To Remember Via Email'} />
                    </MenuItem>
                )}
            </Menu>

            {/* Delete Confirmation Dialog */}
            <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to remove {selectedCaregiver?.FirstName} {selectedCaregiver?.LastName} from this customer account? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                    <Button onClick={handleDeleteConfirm} color="error" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Resend Email/SMS Confirmation Dialog */}
            <Dialog open={resendEmailModalOpen} onClose={() => !Boolean(resendEmailLoading) && setResendEmailModalOpen(false)}>
                <DialogTitle>
                    {resendEmailCaregiver?.UseApp === 1 ? 'Resend Welcome Email' : 'Resend Welcome SMS'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {resendEmailCaregiver?.UseApp === 1 ? (
                            <>
                                Are you sure you want to resend the welcome email to{' '}
                                <strong>{resendEmailCaregiver?.FirstName} {resendEmailCaregiver?.LastName}</strong> at{' '}
                                <strong>{resendEmailCaregiver?.Email}</strong>?
                                
                                {resendEmailCaregiver?.DateAgreed ? (
                                    null
                                ) : (
                                        <><br /><br />This will generate a new temporary password and send account setup instructions.</>
                                )}
                            </>
                        ) : (
                            <>
                                Are you sure you want to resend the welcome SMS to{' '}
                                <strong>{resendEmailCaregiver?.FirstName} {resendEmailCaregiver?.LastName}</strong> at{' '}
                                <strong>{formatPhoneNumbersForDisplay(resendEmailCaregiver?.PhoneNumbers)}</strong>?
                                <br /><br />
                                This will send a text message with important phone numbers and device information.
                            </>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setResendEmailModalOpen(false)} disabled={Boolean(resendEmailLoading)}>
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleResendEmailConfirm} 
                        color="primary" 
                        autoFocus
                        disabled={Boolean(resendEmailLoading)}
                        startIcon={resendEmailLoading && <CircularProgress size={16} />}
                    >
                        {resendEmailLoading ? 'Sending...' : 'Send'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Phone Number Update Sync Dialog */}
            <Dialog 
                open={phoneUpdateModalOpen} 
                onClose={phoneUpdateStatus !== 'checking' && phoneUpdateStatus !== 'adding' ? handlePhoneUpdateModalClose : undefined}
                maxWidth="sm"
                fullWidth
                TransitionProps={{
                    onExited: handlePhoneUpdateModalExited
                }}
            >
                <DialogTitle>Saving New Phone Number</DialogTitle>
                <DialogContent>
                    {/* Step 1: Saving New Phone Number */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1 }}>
                        <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {phoneUpdateStatus === 'adding' ? (
                                <CircularProgress size={24} />
                            ) : phoneUpdateStatus === 'added' || phoneUpdateStatus === 'checking' || phoneUpdateStatus === 'success' ? (
                                <CheckCircleIcon sx={{ color: 'success.main', fontSize: 24 }} />
                            ) : (
                                <RadioButtonUncheckedIcon sx={{ color: 'action.disabled', fontSize: 24 }} />
                            )}
                        </Box>
                        <Typography>Linking new number to Connect App 365.</Typography>
                    </Box>

                    {/* Step 2: Enabling number to call device */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1 }}>
                        <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {phoneUpdateStatus === 'added' ? (
                                <CircularProgress size={24} />
                            ) : phoneUpdateStatus === 'checking' || phoneUpdateStatus === 'success' ? (
                                <CheckCircleIcon sx={{ color: 'success.main', fontSize: 24 }} />
                            ) : phoneUpdateStatus === 'adding' ? (
                                <RadioButtonUncheckedIcon sx={{ color: 'action.disabled', fontSize: 24 }} />
                            ) : (
                                <RadioButtonUncheckedIcon sx={{ color: 'action.disabled', fontSize: 24 }} />
                            )}
                        </Box>
                        <Typography>Setting up call access between this number and {customerName}'s device. Click "Continue" to see when this process is completed.</Typography>
                    </Box>

                    {/* Step 3: Processing / Checking sync status */}
                    {phoneUpdateStatus === 'checking' && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1 }}>
                            <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <CircularProgress size={24} />
                            </Box>
                            <Typography>Processing...</Typography>
                            <Typography variant="caption" color="text.secondary">
                                ({elapsedSeconds} second{elapsedSeconds !== 1 ? 's' : ''} elapsed)
                            </Typography>
                        </Box>
                    )}

                    {/* Step 4: Process Completed */}
                    {phoneUpdateStatus === 'success' && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1 }}>
                            <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <CheckCircleIcon sx={{ color: 'success.main', fontSize: 24 }} />
                            </Box>
                            <Typography>
                                Process Completed.  The new phone number has been successfully added, and {customerName}'s device can now call and receive calls from the new number.
                            </Typography>
                        </Box>
                    )}

                    {phoneUpdateStatus === 'timeout' && (
                        <Alert severity="warning" sx={{ mt: 2 }}>
                            <Typography>
                                Couldn't sync with the device. This can happen for a few reasons: bad cell service, dead battery, etc. Please place the device on the charging cradle to complete syncing the new number.
                            </Typography>
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions>
                    {phoneUpdateStatus === 'added' && (
                        <>
                            <Button onClick={handlePhoneUpdateModalClose}>Close</Button>
                            <Button onClick={startWhitelistPolling} variant="contained" color="primary" autoFocus>
                                Continue
                            </Button>
                        </>
                    )}
                    
                    {phoneUpdateStatus === 'checking' && (
                        <Button onClick={handlePhoneUpdateModalClose} disabled>
                            Processing...
                        </Button>
                    )}
                    
                    {(phoneUpdateStatus === 'success' || phoneUpdateStatus === 'timeout') && (
                        <Button onClick={handlePhoneUpdateModalClose} variant="contained">
                            Close
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CaregiverManagement;
